import React from 'react';
import PropTypes from 'prop-types';

export default function Pencil(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.width} viewBox="0 0 24 24" fill="none" stroke={props.color || 'currentColor'} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit-2" {...props}>
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
  );
}

Pencil.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Pencil.defaultProps = {
  color: '#202020',
  width: 20,
};